import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dialogFirst: false,
    dialogFirstinfo: false,
    dialogubicacion: false,
    banderaUbicacionUsuario:false,
  },
  getters: {
    dialogFirstCall(state) {
      return state.dialogFirst;
    },
    dialogFirstinfo(state) {
      return state.dialogFirstinfo;
    },
    dialogubicacion(state) {
      return state.dialogubicacion;
    },
    banderaUbicacionUsuario(state) {
      return state.banderaUbicacionUsuario;
    },
  },
  mutations: {

    setdialogFirst(state, action){
      state.dialogFirst =  action
    },
    setdialoginfo(state, action){
   
      state.dialogFirstinfo =  action
    },
    setdialogubicacion(state, action){
   
      state.dialogubicacion =  action
    },
    setbanderaUbicacionUsuario(state, action){
   
      state.banderaUbicacionUsuario =  action
    },
  },
  actions: {

  },
  modules: {
  }
})
